export const numDecimals = (num: number) => (value: number) =>
  (Math.round(value * Math.pow(10, num)) / Math.pow(10, num)).toFixed(num)

export const format = (value: any) => {
  return String(value)
    .replace(/(\d{3})/g, '$1,')
    .split(',')
    .join(' - ')
}
